import { Card, CardBody, Col, Label, Table } from "reactstrap";
import CommonToggleHeader from "../Common/CommonToggleHeader";
import { ManageOrders } from "../../../../Constant";
import { MANAGE_ORDER_DATA } from "../../../../Data/Dashboard";
import { ManageOrderTableBody } from "./ManageOrderTableBody";

const ManageOrder = () => {
  return (
    <Col xl="8" lg="7" className="box-col-8">
      <Card>
        <CommonToggleHeader title={ManageOrders} />
        <CardBody className="pt-0 manageorder">
          <div className="table-responsive">
            <div id="transaction_wrapper" className="dataTables_wrapper no-footer">
              <div id="transaction_filter" className="dataTables_filter">
                <Label>Search:<input type="search" /></Label>
              </div>
              <div className="table-responsive theme-scrollbar">
                <Table className="display dataTable" id="manage-order">
                  <thead>
                    <tr>
                      {MANAGE_ORDER_DATA.map((item, index) => (
                        <th key={index}>{item}</th>
                      ))}
                    </tr>
                  </thead>
                  <ManageOrderTableBody />
                </Table>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ManageOrder;
